
















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'

@Component
export default class ComponentHidingWrapper extends mixins(MixinGeneral) {
  @Prop({ type: Number, default: 140 }) readonly maxHeight!: number
  @Prop({ type: String, default: 'Показать полностью' })
  readonly showText!: string

  @Prop({ type: String, default: 'Свернуть' }) readonly hideText!: string

  private mounted() {
    const contentBlock = this.$refs.content as HTMLElement
    if (contentBlock.clientHeight > this.maxHeight) {
      this.hidable = true
    }
  }

  private hidable = false
  private isShow = false

  private toggle() {
    this.isShow = !this.isShow
  }

  private get styleContentWrapper() {
    return {
      maxHeight:
        this.hidable && !this.isShow ? `${this.maxHeight}px` : 'fit-content',
    }
  }
}
